import React, { useCallback, useState } from 'react';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { manageDisableScrolling } from '../../../ducks/ui.duck';
import { PENDING_INTAKE_STATUS } from '../../../constants/listing';
import api from '../../../api';
import {
  FieldRadioButtonGroup,
  FieldTextInput,
  Form,
  Modal,
  PrimaryButton,
  SecondaryButton,
} from '../../../components';

import css from './CustomerDecisionModal.module.css';

const CustomerDecisionModal = props => {
  const { className, isOpen, onClose, listing } = props;

  const intl = useIntl();
  const dispatch = useDispatch();

  const [submitInProgress, setSubmitInProgress] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const classes = classNames(css.root, className);

  const onManageDisableScrolling = useCallback(
    (componentId, disableScrolling) =>
      dispatch(manageDisableScrolling(componentId, disableScrolling)),
    [dispatch]
  );

  const onSubmit = async values => {
    try {
      setSubmitInProgress(true);
      setSubmitError(null);

      const body = { leaseExpirationOption: values?.leaseExpirationOption };

      await api.listings.setContractExpirationOptions(listing.id.uuid, body);

      await api.listings.updateListing(listing.id.uuid, {
        metadata: {
          dateLeaseExpirationOptionSet: new Date(),
          leaseExpirationOptionComment: values.leaseExpirationOptionComment,
        },
      });

      onClose();
      window.location.reload();
    } catch (error) {
      setSubmitError(error);
      console.error(error);
    } finally {
      setSubmitInProgress(false);
    }
  };

  return (
    <Modal
      id="CustomerDecisionModal"
      isOpen={isOpen}
      onClose={onClose}
      usePortal
      onManageDisableScrolling={onManageDisableScrolling}
      className={classes}
    >
      <FinalForm
        onSubmit={onSubmit}
        initialValues={{ leaseExpirationOption: '', leaseExpirationOptionComment: '' }}
        render={formProps => {
          const { handleSubmit, values } = formProps;

          return (
            <Form onSubmit={handleSubmit} className={css.form}>
              <div className={css.title}>
                {intl.formatMessage({ id: 'ContractLeaseActions.customerDecision' })}
              </div>

              <FieldRadioButtonGroup
                className={css.radioGroup}
                name="leaseExpirationOption"
                options={Object.values(PENDING_INTAKE_STATUS).map(option => ({
                  name: option,
                  value: option,
                  label: intl.formatMessage({ id: `General.${option}` }),
                }))}
              />

              <FieldTextInput
                name="leaseExpirationOptionComment"
                id="leaseExpirationOptionComment"
                type="text"
                className={css.commentField}
                label={intl.formatMessage({
                  id: 'ContractLeaseActions.expirationOptionComment',
                })}
              />

              {submitError && (
                <p className={css.error}>{intl.formatMessage({ id: 'General.error' })}</p>
              )}

              <div className={css.btns}>
                <SecondaryButton type="button" onClick={onClose}>
                  {intl.formatMessage({ id: 'General.cancel' })}
                </SecondaryButton>

                <PrimaryButton
                  type="submit"
                  disabled={submitInProgress || !values?.leaseExpirationOption}
                  inProgress={submitInProgress}
                  className={css.submit}
                >
                  {intl.formatMessage({ id: 'General.confirmDecision' })}
                </PrimaryButton>
              </div>
            </Form>
          );
        }}
      />
    </Modal>
  );
};

export default CustomerDecisionModal;
